/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, arrayOf, shape, string, bool, func,
} from 'prop-types';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { dateMMMMDDYYYY } from '../../utils/dateString';
import DesktopOrderListItem from './DesktopOrderListItem';
import { deepObjectExtend, isEmpty } from '../../utils/object';
import { combineStyle } from '../../style/combineStyle';
import { getAddToCartError } from '../../../../../state/ducks/AddToCart/AddToCart-Selectors';
import { main as MainStyle } from '../../style/main';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { DesktopOrderListStyle } from '../../style/DesktopOrderListStyle';
import { getCryptedOrderDetailsURL } from '../../utils/crypto';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import { getIsAuthenticatedStatus } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';

const styles = ({ typography, palette }) => deepObjectExtend(
    combineStyle(typography, palette, {
        MainStyle,
        DesktopOrderListStyle,
    }),
);

class DesktopOrderList extends PureComponent {
    scrollTop = () => {
        if (typeof window !== 'undefined') {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    };

    handleViewDetailsClicked = async (
        uuid,
        orderNumber,
        paymentStatus,
        status,
        trackingNumber,
        carrier,
    ) => {
        const {
            fetchOrderDetails, history, featureFlags, ssrDeviceType, isAuthenticatedStatus,
        } = this.props;
        if (orderNumber && uuid) {
            const isROSSEnabled = featureFlags['is-order-page-using-ross-endpoint'] || false;
            // for graphQL ONLY: fetching order details to update trackingNumber and carrier
            // because we couldn't get them from getOrdersByEmailId call in the fetchOrdersByEmail()
            if (!isROSSEnabled) {
                await fetchOrderDetails(uuid, orderNumber, null, null, {
                    update: true,
                    paymentStatus,
                    status,
                    trackingNumber,
                    carrier,
                },
                featureFlags,
                ssrDeviceType,
                isAuthenticatedStatus);
            }
            // redirect to the order detail page
            const ordersURL = getCryptedOrderDetailsURL(orderNumber, uuid);
            history.push(ordersURL);
        }
    };

    render() {
        const {
            classes,
            order,
            ROSSOrder,
            userProfile,
            featureFlags,
            addToCartError,
            isROSSUIEnabled,
        } = this.props;

        const isBuyAgainEnabled = featureFlags['is-order-history-buy-again-enabled'];
        // There is a discrepancy of Order Details' API response between login and guest account.

        let carrier; let trackingNumber; let paymentStatus; let
            status;
        if (order) {
            [{
                carrier, trackingNumber, paymentStatus, status,
            }] = order?.items;
        }

        const orderDate = order?.orderPlaceddate;
        const ROSSOrderDate = ROSSOrder?.orderPlacedDate;
        const orderDateString = dateMMMMDDYYYY(orderDate);
        const ROSSOrderDateString = dateMMMMDDYYYY(ROSSOrderDate);
        const hasOrderSpecific = order?.orderNumber?.includes('3410286682');
        return isROSSUIEnabled && !isEmpty(ROSSOrder) ? (
            <div className={classes.DesktopOrderListStyle}>
                <Grid container>
                    <Grid item xs={12}>
                        <Grid key={ROSSOrder.intOrderNumber} className={`${classes.orderProductMain} order-list-wrapper`}>
                            <Grid className="orderHeader" container>
                                {/* View / Manage Order */}
                                <Grid container item xs={4}>
                                    <Button
                                        variant="contained"
                                        className="quaternary text-transform-none"
                                        onClick={() => this.handleViewDetailsClicked(
                                            ROSSOrder.uuid,
                                            ROSSOrder.orderNumber,
                                            null,
                                            ROSSOrder.items[0].paymentStatus,
                                            ROSSOrder.items[0].trackingNumber,
                                            ROSSOrder.items[0].carrier,
                                        )}
                                    >
                                        {ROSSOrder.modifyOrder === 'true'
                                            ? 'View / Manage Order'
                                            : 'View Order'}
                                    </Button>
                                </Grid>
                                {/* Order # | Replacement For: */}
                                <Grid container item xs={4}>
                                    {/* Order # */}
                                    <Grid className="orderHeaderItem">
                                        <span className="headerItemLabel">Order #: </span>
                                        <span>{ROSSOrder.orderNumber}</span>
                                    </Grid>
                                    {/* Replacement For: */}
                                    {ROSSOrder.parentOrderNumber
                                        ? (
                                            <Grid className="orderHeaderItem align-center">
                                                <span className="headerItemLabel">Replacement For: </span>
                                                <span>{ROSSOrder.parentOrderNumber}</span>
                                            </Grid>
                                        )
                                        : <Grid className="orderHeaderItem" />}
                                </Grid>
                                {/* Order Date: */}
                                <Grid className="orderHeaderItem" item xs={4}>
                                    <span className="headerItemLabel">Order Date: </span>
                                    <span className="orderDate">{ROSSOrderDateString}</span>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    ROSSOrder.items.map((ROSSItem, i) => (
                                        <DesktopOrderListItem
                                            key={['_', i].join('')}
                                            classes={classes}
                                            orderNumber={ROSSOrder.orderNumber}
                                            index={i}
                                            uuid={ROSSOrder.uuid}
                                            hasOrderSpecific={hasOrderSpecific}
                                            isBuyAgainEnabled={isBuyAgainEnabled}
                                            userProfile={userProfile}
                                            ROSSOrder={ROSSOrder || null}
                                            ROSSItem={ROSSItem}
                                            addToCartError={addToCartError}
                                            isROSSUIEnabled={isROSSUIEnabled}
                                        />
                                    ))
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {addToCartError?.length > 0 && this.scrollTop()}
            </div>
        ) : (
            <div className={classes.DesktopOrderListStyle}>
                <Grid container>
                    <Grid item xs={12}>
                        <Grid key={order?.intOrderNumber} className={`${classes.orderProductMain} order-list-wrapper`}>
                            <Grid className="orderHeader" container>
                                <Grid container item xs={4}>
                                    <Button
                                        variant="contained"
                                        style={{ textTransform: 'none' }}
                                        className="quaternary"
                                        onClick={() => this.handleViewDetailsClicked(
                                            order?.uuid,
                                            order?.orderNumber,
                                            paymentStatus,
                                            status,
                                            trackingNumber,
                                            carrier,
                                        )}
                                    >
                                        {order?.modifyOrder === 'true'
                                            ? 'View / Manage Order'
                                            : 'View Order'}
                                    </Button>
                                </Grid>
                                <Grid container item xs={4}>
                                    <Grid className="orderHeaderItem">
                                        <span className="headerItemLabel">Order #: </span>
                                        <span>{order?.orderNumber}</span>
                                    </Grid>
                                    {order?.parentOrderNumber
                                        ? (
                                            <Grid className="orderHeaderItem align-center">
                                                <span className="headerItemLabel">Replacement For: </span>
                                                <span>{order?.parentOrderNumber}</span>
                                            </Grid>
                                        )
                                        : <Grid className="orderHeaderItem" />}
                                </Grid>
                                <Grid className="orderHeaderItem" item xs={4}>
                                    <span className="headerItemLabel">Order Date: </span>
                                    <span className="orderDate">{orderDateString}</span>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                {
                                    order?.items?.map((data, i) => (
                                        <DesktopOrderListItem
                                            key={['_', i].join('')}
                                            classes={classes}
                                            orderNumber={order?.orderNumber}
                                            index={i}
                                            uuid={order?.uuid}
                                            items={data}
                                            hasOrderSpecific={hasOrderSpecific}
                                            isBuyAgainEnabled={isBuyAgainEnabled}
                                            userProfile={userProfile}
                                            ROSSOrder={ROSSOrder || null}
                                            addToCartError={addToCartError}
                                            isROSSUIEnabled={isROSSUIEnabled}
                                        />
                                    ))
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {addToCartError?.length > 0 && this.scrollTop()}
            </div>
        );
    }
}

DesktopOrderList.propTypes = {
    classes: object.isRequired,
    order: shape({
        orderNumber: string,
        intOrderNumber: string,
        orderPlaceddate: string,
        customerFirstName: string,
        customerLastName: string,
        modifyOrder: string,
        parentOrderNumber: string,
        uuid: string,
        items: arrayOf(
            shape({
                brandId: string,
                productSku: string,
                productName: string,
                recpFirstName: string,
                recpLastName: string,
                shipDate: string,
                paymentStatus: string,
                estimatedDeliveryDate: string,
                trackingNumber: string,
                itemType: string,
                sfItemType: string,
                addonType: string,
                parentLineNumber: string,
                childLineNumber: string,
                flexDate: string,
                flexMessage: string,
                flexGuaranteedFlag: string,
                prdImgCtg: string,
                prdImgTmn: string,
                arrivalStartDate: string,
                arrivalEndDate: string,
                carrier: string,
                seoUrl: string,
                subscriptionType: string,
                interval: string,
                duration: string,
            }),
        ),
    }).isRequired,
    ROSSOrder: arrayOf({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        modifyOrder: string,
        uuid: string,
        status: string,
        items: arrayOf(
            shape({
                duration: string,
                interval: string,
                itemType: string,
                prdImgCtg: string,
                prdImgTmn: string,
                productName: string,
                productSku: string,
                seoUrl: string,
                subscriptionType: string,
            }),
        ),
    }),
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
    featureFlags: shape({
        'is-order-history-buy-again-enabled': bool,
    }).isRequired,
    addToCartError: string.isRequired,
    isROSSUIEnabled: bool.isRequired,
    uuid: string.isRequired,
    history: object.isRequired,
    fetchOrderDetails: func.isRequired,
    ssrDeviceType: string.isRequired,
    isAuthenticatedStatus: bool.isRequired,
};

DesktopOrderList.defaultProps = {
    ROSSOrder: {},
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
    addToCartError: getAddToCartError(state),
    ssrDeviceType: getSSRDeviceType(state),
    isAuthenticatedStatus: getIsAuthenticatedStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchOrderDetails: (uuid, orderNumber, zipCode, billingZipCode, options, featureFlags, ssrDeviceType, isAuthenticatedStatus) => dispatch(EventDispatcher.fetchOrderDetails(
        uuid,
        orderNumber,
        zipCode,
        null,
        options,
        featureFlags,
        ssrDeviceType,
        isAuthenticatedStatus,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(withRouter(DesktopOrderList)));
